import axios from "axios"

const state = {
    userInfo: {
        placeholderData: true,
        firstName: 'Sports Fan',
        lastName: '',
        ownerName: "Broncos Fan",
        year: 'XXXX',
        repName: 'Rep Name',
        repEmail: 'ref@team.com',
        repPhone: '(000)-000-0000',

    },
    loadedItems: {
        images: false,
        video: false,
        userInfo: false,
        fonts: false
    },
    allUserAccs: [],
    allParkingAccs: [],
    isMobile: false
}

const getters = {
    getUserInfo: (state) => state.userInfo,
}


const actions = {
    async fetchUserInfo({ commit }) {
        const purl = location.pathname.split('/')[2];
        const response = await axios.post(process.env.VUE_APP_BASE_URL + '/api/router/Users.php', {
            action: "getUserByPurl",
            prefix: "broncos2025extension_accounts",
            purl: purl,
            timestamp: new Date()
        })

        commit('setUserInfo', response ? response.data : 'fetchUserInfoFailed');
        commit('setLoadedItem', {
            loadedProperty: 'userInfo',
            isLoaded: true
        });
    },
    async setLoadedItem({ commit }, payload) {
        commit('setLoadedItem', payload)
    },
    async setUserInfoObject({ commit }, payload) {
        commit('setUserInfoObject', payload)
    },
    async setIsMobile({ commit }, payload) {
        commit('setIsMobile', payload)
    }
}

const mutations = {
    setUserInfo: (state, payload) => {
        if (!payload.output || payload.output.length < 1) return;
        let userInfo = payload.output[0];
        state.userInfo = userInfo;
        state.allUserAccs = payload.output;
    },
    setUserInfoObject: (state, payload) => {
        if (!payload) return;
        state.userInfo = payload;
    },
    setLoadedItem: (state, payload) => {
        state.loadedItems = {
            ...state.loadedItems,
            [payload.loadedProperty]: payload.isLoaded
        }
    },
    setIsMobile: (state, payload) => {
        state.isMobile = payload;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}